webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_botui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_botui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_botui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moveto__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moveto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moveto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_botui_build_botui_min_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_botui_build_botui_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_botui_build_botui_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_botui_build_botui_theme_default_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_botui_build_botui_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_botui_build_botui_theme_default_css__);






if (document.getElementById('pageNotFoundBot')) {
  var botui = __WEBPACK_IMPORTED_MODULE_1_botui___default()('pageNotFoundBot', {
    vue: __WEBPACK_IMPORTED_MODULE_0_vue___default.a
  });

  var notFound = function notFound() {
    botui.message.add({
      content: 'https://giphy.com/embed/9J7tdYltWyXIY',
      type: 'embed',
      loading: true,
      delay: 100
    }).then(function () {
      botui.message.add({
        delay: 1000,
        content: 'You seem to have lost your way!'
      }).then(function () {
        botui.action.button({
          action: [{
            text: 'Go Back!',
            value: true
          }]
        }).then(function () {
          window.open('http://animeshmanglik.name');
          window.focus();
        });
      });
    });
  };

  window.onload = function () {
    notFound();
  };
}

if (document.getElementById('my-botui-app')) {
  var _botui = __WEBPACK_IMPORTED_MODULE_1_botui___default()('my-botui-app', {
    vue: __WEBPACK_IMPORTED_MODULE_0_vue___default.a
  });

  var moveTo = new __WEBPACK_IMPORTED_MODULE_2_moveto___default.a();

  var social = function social() {
    _botui.message.add({
      delay: 1000,
      content: 'Connect with me.'
    }).then(function () {
      _botui.action.button({
        action: [{
          icon: 'linkedin',
          text: 'linkedin',
          value: true
        }]
      }).then(function () {
        window.open('https://www.linkedin.com/in/animeshmanglik', '_blank');
        window.focus();
      });
    });
  };

  var portfolio = function portfolio() {
    _botui.message.add({
      delay: 1000,
      content: 'Wanna see my projects?'
    }).then(function () {
      _botui.action.button({
        action: [{
          text: 'Yes',
          value: true
        }, {
          text: 'No',
          value: false
        }]
      }).then(function (project) {
        if (project.value) {
          var target = document.getElementsByClassName('projects')[0];
          moveTo.move(target);
        }
        _botui.message.add({
          delay: 1000,
          content: 'How about work experience?'
        }).then(function () {
          _botui.action.button({
            action: [{
              text: 'Yes',
              value: true
            }, {
              text: 'No',
              value: false
            }]
          }).then(function (experience) {
            if (experience.value) {
              var _target = document.getElementsByClassName('experience')[0];
              moveTo.move(_target);
            }
          }).then(function () {
            social();
          });
        });
      });
    });
  };

  var initial = function initial() {
    // First my image
    _botui.message.add({
      content: 'https://animeshmanglik.name/static/img/image/image.html',
      type: 'embed',
      delay: 1000,
      loading: true
    }).then(function () {
      _botui.message.add({
        delay: 1000,
        content: 'Welcome to TL; DR version of my website.'
      }).then(function () {
        _botui.message.add({
          delay: 1000,
          loading: true,
          content: 'Hows your day going?'
        }).then(function () {
          _botui.action.button({
            action: [{
              text: 'Great',
              value: true
            }, {
              text: 'Meh!',
              value: false
            }]
          }).then(function (day) {
            if (day.value) {
              _botui.message.add({
                content: 'https://giphy.com/embed/1MTLxzwvOnvmE',
                type: 'embed',
                loading: true,
                delay: 100
              });
            } else {
              _botui.message.add({
                content: 'https://giphy.com/embed/BmMU3LOfNMMeI',
                type: 'embed',
                loading: true,
                delay: 100
              });
            }
          }).then(function () {
            portfolio();
          });
        });
      });
    });
  };

  window.onload = function () {
    initial();
  };
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(4);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;

__webpack_require__(20);
__webpack_require__(33);
__webpack_require__(31);
__webpack_require__(32);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

if (navigator.userAgent.indexOf('Speed Insights') === -1) {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
    id: 'UA-44706150-1',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]
  });
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Portfolio__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Portfolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Portfolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageNotFound__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageNotFound__);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Portfolio',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Portfolio___default.a
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PageNotFound___default.a
  }]
}));

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vanilla_tilt__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vanilla_tilt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vanilla_tilt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sections_BackgroundAnim__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sections_BackgroundAnim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sections_BackgroundAnim__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'left',
  components: {
    VanillaTilt: __WEBPACK_IMPORTED_MODULE_0_vanilla_tilt___default.a,
    BackgroundAnim: __WEBPACK_IMPORTED_MODULE_1__sections_BackgroundAnim___default.a
  },
  methods: {
    startTilt: function startTilt() {
      __WEBPACK_IMPORTED_MODULE_0_vanilla_tilt___default.a.init(document.querySelector('.left-inner'), {
        max: 25,
        speed: 400
      });
    }
  },
  mounted: function mounted() {
    this.startTilt();
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pageNotFound'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Left__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Right__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Right__);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'portfolio',
  components: {
    Left: __WEBPACK_IMPORTED_MODULE_0__Left___default.a,
    Right: __WEBPACK_IMPORTED_MODULE_1__Right___default.a
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_Experience__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_Experience___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_Experience__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sections_Projects__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sections_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sections_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sections_Additional__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sections_Additional___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sections_Additional__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sections_Education__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sections_Education___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sections_Education__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sections_Playground__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sections_Playground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sections_Playground__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sections_Footer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sections_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sections_Footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'right',
  components: {
    Experience: __WEBPACK_IMPORTED_MODULE_0__sections_Experience___default.a,
    Projects: __WEBPACK_IMPORTED_MODULE_1__sections_Projects___default.a,
    Additional: __WEBPACK_IMPORTED_MODULE_2__sections_Additional___default.a,
    Education: __WEBPACK_IMPORTED_MODULE_3__sections_Education___default.a,
    Playground: __WEBPACK_IMPORTED_MODULE_4__sections_Playground___default.a,
    Social: __WEBPACK_IMPORTED_MODULE_5__sections_Footer___default.a
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'additional'
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'backgroudAnim'
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'education'
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'experience'
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_Animesh_Manglik_Resume_2017_pdf__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_Animesh_Manglik_Resume_2017_pdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_Animesh_Manglik_Resume_2017_pdf__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer',
  data: function data() {
    return {
      github: 'https://github.com/animeshmanglik',
      linkedin: 'https://www.linkedin.com/in/animeshmanglik',
      resume: __WEBPACK_IMPORTED_MODULE_0__assets_Animesh_Manglik_Resume_2017_pdf___default.a
    };
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'playground'
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects'
});

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAC2ElEQVQ4jSXBy27jVACA4d8+x07sOE6c3tIbM2SGIkBCgsWskVjxJDwLz4bQLIACqmZUOi00UydNYh/HPjez4PuCH378qXedYpyPuTwdIVXNrjZo17J9VrR9TFwcQO/wPf8LBHiHsT1STD8hBqKB4Gg+ANMTK0eWam4fNUqD9T3GOryzWOtx3tOH4EODnF98gQgDZBjwZALwGiMUpTLogWFv91jXYbzGuh7vPc5Y8A5rNGEwOsTEOftgwCSHi5kidBVXZ4ZclBjdYExH4DvCvkMGjhBN7/d4UyOtc+xUQ+BbNmFDnqx50d7x81tJvV4xES1Ln2FbhdA7gvIGeTRl35+i9y1y1Si87fBqzV/LNfd9jbq55vdf/6RrtmAMIhII0XM8asiLiDC/pN6FeO+RVitMVeLUCqs2tBjseM786wFG7Qg//Ma72zus19Srnv5BEvyx5uTT1/ggQrbl35iqxFYfCW1DNBpgTAO6Iost33w24eTiW550j8imxFnG+v0Nb47h+skh1fIdAku3eaTXCttlpLEhSiO88bytM86HLXp8yHBaUG+3ZIdH/LLeMKRB7ldL8mlK4Bqc0/i2QqmGeJgQDSLS+ZxSa158vuB5tSFuBYNkgnWOauORUdhhG0WSCsIsZ5TGVM+GLI85Ojtnu16RjAuEjAlFgHOe8WTCgZB475Ch6HG6YZDEHJ9OGRcFs5MjktGQTfnEulzz6qsvCcOefJLRNQ3pKCUvCqJhijxbvCawFZtyRbPXKPVAXhwgB0PyWUG1rWhbw/L+HqMNi6tXZLNj6qomdyDffPc9plUsHz7QbEv+vbulVprOlBRFTiATHv/5iO1a1HaHqq+5XNQMkxFSSGQcZ0RyyOJqSqO2nL1cIALPII7xfUCaH9I0LdvVmrqqaJUCkXB4ckyUFMhIxgiZkKUx/cEMqzu6rsN7i+46zl9O8N7grEW3HappMMYxyifISPIfA9yrEJNsre4AAAAASUVORK5CYII="

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAJ0ElEQVRYhT2XybJk11WGv92cJvvM21QrGakUYUMBIiwmzJgwYKAI8wY8AC/BjDFT3oIH8MwQEAQTW8jY4bAoqap067aZeU6ebu+1FoMrGOzZ2hGr/7/lfvZ3/2B5Sox9S1EUlFXJ+bNnXGwKmrsbClEYB8xFHpojh6YjpYxPPcdWCNUSxbH7g09xPuBQsgGawYGZUoSAGmQRmDKuKDEzpmEk9rnGXIGvwqNBDjzct0SreXJ5Sep6yrHkODjCouaTpyXbtePbty0XLtJMEL2RfUDN8ECQCRcK1DlUQZ3HhYIYlFAboqBiRF8Ri81zyB0Bw4UaHwKzQnnyvORsYZSXGw73iSI7qmngyU6pXMehqTkOnlkIqC/wzqMqZDHKOpAlgxpmDjFDMcwCJgAe54SMEGMMqF9hCLGs8RhVmQmhRlzJvjeaPOGcJ1RrGlHukzItPL4WShVSFlQyqOBFSaqoVxKCimGWETNQMAxMQQ2VTFysLzFJABQhEMuSMkQeUqSxiDNDyoRZBss0E4gIFg1DGNJAEkM14gyGrACogoiBGVnBmaGqYIrHEBVSzsTd5SfUZYXzoCKoPkaiklFnmE2YZlLOZJlQM3LKqCiixpAz8n//RFEDU0VNEDWcKZg8Oi0JZw5xhopAHonZFZxyxjtHlkxASTkRUOqQcCTUJswyzoxgiboydmvPN+8nTAWVRHCBUSbMFEfGoxiCqOAw0IxDwT1mwSSTU090PnAaJ8wEU8Wb4p0QQuJv/iKA9Pzq6wfeXiUGDXzyUcVf/fmcn//8l3x9H7BijRNhyELACF5wKJNMlN5RFTVj6hA8SUY0C6BEr2SnxFVd0E8D/ZRAFVOh8IrXzJvvW376qaN7uGHRnthVFf/1a89Xv3Vcf8hs5QqddexzhXOQRUlpQCXhnZFVuLt5j04H/uyLFb+/eYakH0oyZcaux/3tP31jx2EAVVQEbwmnE4GRTZGpw0QYTnz5vOWf/+MbvuWCpEYee3J35MfxPX3Y8M7WTOqwNGLTCcsTq/GGj8MDv/nuincPDZ9/+TOubiNpeuwHw4iHYUTVMBGwjKYJUsuYOiaESOJSb/nP/RX/+u9fcWh6cp7IaSJPI782faytD2yfXFDNFrR3V5z5jvgS0mLDRz8+43LaMjTX9IfF43RgxCoQ1RQ1BR690twj3RFNPUNKFBE6cXx9nRnijDHtSX2DpAHLCRPFe4/kkavjLZZHsgy0pWcca37VfMt8VfDJFx/z/bVH88jjYAjdKeO+/MevzGQidy3OKzZ25OYOSxOSRzChjEYeOqZxYOob8jAwnRpSu+fw9g2p3ZPSgFlGJYFTIkpdFvQpPy6fGNg9+5TNs6eAJ2chqydq6pGuIXdHVCbIPXnosDyBCSHA2E9I6lGZCE5wdaAoN8SLNX/ycoG8+Ypf/G4kuRInDnCYKYODsFgQypKpabh//z/IdGLz9BliHsuZKGPL1NyT+xZsQscOZ4noFHJPFQMSYJyEEJRpGHF5IATPFuH1rOW7p2f80fkLTiN4hKxG9iXzzYZQzQDj+P0Vh9/9kr/+yZZbX/LftxnJiZiON0i/x6sgeWBqPuA0M6URZ4lwtiW7Csk9eZqwlMh9oiwdt03Hb2j5fFdSHB37s5J3JwWD1XaL9yXFvEZTJq9nzF5/TnmWea6Op+sV//LbgfDyT//y700mcIL0Lak/ImNPHgYkT4xJiD7gyRTe0JTBQxEfpfZ+NN7ePrCSO37y6UsOuULrGc8//ghJmSI48jQSnGcYM9/sHQ9Nx7IY6MWIp7sbYhGoZwUynnAyPT5GvPc4zejUUrqeOkzMtytivSKNE8OppTx7TneY84aRN9+2WL2iqGcMXY+Icvv9B1br+eP2Kzwijv0Q+be3iZSVOJ4atAwUcUF0iunIOA2UhQMTNtsVx7trUm4ZywrVAz401PMKHwKGo5gvGQcHzvHxj16w2OxomhPHQ0MsPS56ogv4XOKy4WKELHiNxOAFD5gkFqsZ7RgJyUhZGbqRfnhLUXqiq8hJwStn508Z+wERYbEIxNUc0SWmymp3zmq3pqwK2mNLjHD5dEuIJR/eX1PPKoauwqWR07HF17OIZ6JwI/3xFjRR1REfPNWyYjYv2e7WzOY1zguLuScE4dXrV5w9u0DkUcZPTcOUM85BfxoQMWbzEjPH4f6IOs9yt2O5WVPNSigiflYRU98SndDtWxyZoggsN1uc88znNav1nHa/5+ZqYDavUPUs1iuq2QynN1QzIwTjxflHFFVFUVYMQ+Lu+gM5DTiU+/ueISmr7Y6iKqlmC/rThOKIRVk8goIIpkLwEQwun+6o5yXlbM7QtazPdqjBfFGz2GwY+oSo8uHtDaEoePWHF4g+UtJ8UeGfXXJq9tycGmIRyFMmBqOcLZEkbC/PKMpLIj4QfE1WoSwKVJVT23JzNVLVJbsnz7h4+THn5ijLQChKuvZId9zT7A8455ktV2QRtusFCnTNAecD6+2WEApSVrZnW6rZDFFjtdnw8NDQdR2xmi2oKk9kwXA6Mg4T9WzOfDWnjErX3NPu99TLFZvdOaIjoSiZLxfsnj0lf/cOHyLdqWe5XDAOIx/eviFlqGYVi1nJq9evGSdFs+BcwHljsVqTkxA/+uwzFqsZ0Rt3b3/P/uGAuUjbJVLf4n9gxfmonNqOs4sLyrokxJLNbsfpcKReLCmrGQ/7jv3NNd2+QVSp5y8oF2vGYWSxvqDrR3QcOdwfEelZbhbEP/7ip6CCaWa1XvPh/QfSNHA63lPNarrmxDQ2lNnYXey4vrpjGDqev3jCerujXmw5tS0uVNxeXSNTTygrumPP3dU197cH7m72XD7dU8wWmBldc6SIQlVsiUUx+wEklc25xxePt0EMxvW777i9/sDYLVAxbj/cMFvUvPrRZ2jOHPYHnHf0w0jTvkdyZr5YMJxOj3KbMzEmxq5nbFsuXz5jtd1yeXlB2/WE6oxY1XOGfsBMieWKs/MlkBFJ7J4IoShx3lPEiCdTFgXOO7Znl1y9+w5cRIkkUUKInA57QmmsziumaUKmTIwO8SXmSoJ3CJHldkFdz4kqhvMQCMQQEM04PJKU5eYpZ+dPAEPzSAiOWFT/DxTnL15xdvmC4JVhFLpuZOw7uu5ESpn22DCNA5iyXNZcXJ5ztlvjvaOcb0jJEc08VTHHBU8RPHUVKMvI0J0wM9SUNA7AElEwzfjggYSIIUQMT1Fnln5gsVyzFWGaJqbLiaHrUDyoEusZFGvmiznmYBgH4rwuSCnhnccZqBqqEMsZMQbyNBKdR3B0zQlcoIgllg1HpioeT29VY16vMYNxHJjVM0BJeUffj4xTJqdE006kyaiqErPA/wLJG3/niapeMQAAAABJRU5ErkJggg=="

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "data:image/x-icon;base64,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"

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/pdf/Animesh_Manglik_Resume_2017.fd9dbc1.pdf";

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(56),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(59),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(50),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(49),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e4a9da2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(57),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(52),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(58),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(55),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(53),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(60),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('left'), _vm._v(" "), _c('right')], 1)
},staticRenderFns: []}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageNotFound"
  }, [_c('div', {
    staticClass: "left-bg"
  }, [_c('div', {
    staticClass: "botui-app-container",
    attrs: {
      "id": "pageNotFoundBot"
    }
  }, [_c('bot-ui')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "education"
  }, [_c('h3', [_vm._v("Education")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "university"
  }, [_c('a', {
    attrs: {
      "href": "https://www.usc.edu/",
      "target": "_blank"
    }
  }, [_vm._v("University of Southern California")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("2012 — 2014")])]), _vm._v(" "), _c('div', {
    staticClass: "college"
  }, [_vm._v("Master of Science in Computer Science")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "university"
  }, [_c('a', {
    attrs: {
      "href": "http://www.vit.ac.in/",
      "target": "_blank"
    }
  }, [_vm._v("VIT University")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("2008 — 2012")])]), _vm._v(" "), _c('div', {
    staticClass: "college"
  }, [_vm._v("Bachelor of Technology in Computer Science & Eng.")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "additional"
  }, [_c('h3', [_vm._v("Additional")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "http://codeschool.com/users/933700/",
      "target": "_blank"
    }
  }, [_vm._v("CodeSchool Report")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Brushing up on fundamentals when needed")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "https://github.com/cygri/pubby/pull/22/",
      "target": "_blank"
    }
  }, [_vm._v("Open Source Pubby Project")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("UI/UX updates to the Pubby Project.")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title"
  }, [_vm._v("Certified Scuba Diver")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("My love for water")])])])])
}]}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playground"
  }, [_c('h3', [_vm._v("Playground")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Am working on putting up all my experiments and hacks.")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "playground-img"
    }
  })])
}]}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "experience"
  }, [_c('h3', [_vm._v("Experience")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "http://www.whalerockindustries.com/",
      "target": "_blank"
    }
  }, [_vm._v("Whalerock Digital Media LLC.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Jul '16 — Current")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Software Engineer, Fullstack")])]), _vm._v(" "), _c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "https://www.leafgroup.com/",
      "target": "_blank"
    }
  }, [_vm._v("Demand Media Inc.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Sep '15 — Jun '16")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Sr. Software Engineer")])]), _vm._v(" "), _c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "https://www.leafgroup.com/",
      "target": "_blank"
    }
  }, [_vm._v("Demand Media Inc.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Jun — Sep '15")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Software Engineer")])]), _vm._v(" "), _c('div', {
    staticClass: "exp-item"
  }, [_c('div', {
    staticClass: "job"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": "https://www.leafgroup.com/",
      "target": "_blank"
    }
  }, [_vm._v("Demand Media Inc.")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("Feb — May '14")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Software Engineer Intern")])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "left-footer"
  }, [_c('a', {
    staticClass: "resume",
    attrs: {
      "href": _vm.resume,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "resume-link"
  }, [_vm._v("Resume PDF")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right-footer"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.github,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.linkedin,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v(" ©Animesh 2017")])])
}]}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "right-inner"
  }, [_vm._m(0), _vm._v(" "), _c('education'), _vm._v(" "), _c('projects'), _vm._v(" "), _c('playground'), _vm._v(" "), _c('experience'), _vm._v(" "), _c('additional'), _vm._v(" "), _c('social')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction"
  }, [_c('h3', [_vm._v("Introduction")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Namaste! 🙏 My name is Animesh Manglik and I develop for Web and Mobile ")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Welcome to the TL;DR version of my website which I am currently redesigning. This has been a fun experiment, make sure you interact with the phone on the left")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Hope you have a great day!")])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backgroudAnim",
    staticStyle: {
      "display": "none"
    }
  }, [_c('svg', {
    attrs: {
      "width": "1",
      "height": "1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1100 800"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M781.02 488.77v69.78c0 1.08-.88 1.96-1.97 1.96l-135.12-.04c-1.09 0-2.6.62-3.38 1.39l-39.23 38.96a5.52 5.52 0 0 1-3.37 1.4h-75.38a1.97 1.97 0 0 1-1.97-1.97v-33.5"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M674.88 355.57l45.54-45.24a5.42 5.42 0 0 0 1.39-3.35l-.06-10.38c0-1.08-.63-2.58-1.4-3.35l-43.38-43.07a1.94 1.94 0 0 1 0-2.77l82.83-82.25a5.52 5.52 0 0 1 3.37-1.4l44.94.1c1.08 0 2.6-.62 3.37-1.37L952.5 22.65"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M507-76.68v265.47a4 4 0 0 0 4 3.99H566c1.08 0 1.97.88 1.97 1.96v147.5c0 1.08-.63 2.59-1.4 3.35l-47.9 47.4a5.45 5.45 0 0 0-1.4 3.34c0 2.25.64 3.76 1.4 4.53l53.82 53.26c.77.76 1.76 1.39 2.19 1.39.43 0 .79.88.79 1.96v70.17c0 1.07-.89 1.96-1.97 1.96l-85.81-.04c-1.09 0-2.6.62-3.38 1.39l-1.55 1.54a5.52 5.52 0 0 1-3.38 1.4h-9.29"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M8 127.82v391.06a4.04 4.04 0 0 0 4 4.04L140.8 524"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M894.01 374l49.8-49.44a5.52 5.52 0 0 1 3.37-1.4h92.41c1.09 0 2.6.63 3.38 1.4l27.18 26.99"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M894.01 374l49.8-49.44a5.52 5.52 0 0 1 3.37-1.4h92.41c1.09 0 2.6.63 3.38 1.4l27.18 26.99"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M755.16 213.9l70.82.04c1.08 0 2.6-.63 3.37-1.4l91.61-90.97a5.52 5.52 0 0 1 3.37-1.39h77.07l-71.29-72.13a5.45 5.45 0 0 1-1.4-3.35V16.87"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M261.78-52.44l11.16 11.08c.77.77 1.4 2.28 1.4 3.35V-5L156.7 111.03l-85.4 84.8a5.45 5.45 0 0 0-1.4 3.35v100.67c0 1.08.89 1.96 1.97 1.96h50.4c1.09 0 1.98.88 1.98 1.96l.07 26.92c0 1.07.9 1.96 1.98 1.96l335.73.13c1.09 0 1.98.88 1.98 1.96v36.79l-42.99 43.78a5.52 5.52 0 0 1-3.37 1.4H385.2"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M564.8 549.64v17.76c0 1.08-.64 2.59-1.4 3.35L382.28 750.6a5.52 5.52 0 0 1-3.38 1.39h-109.1c-1.09 0-1.97.88-1.97 1.96v23.37c0 1.07-.9 1.96-1.98 1.96h-83.54c-1.08 0-1.97.88-1.97 1.96v45.8c0 1.07.89 1.95 1.97 1.95h29.89c1.08 0 1.97.88 1.97 1.96v51.07c0 1.08.63 2.59 1.4 3.35l10.32 10.25c.77.76 2.29 1.39 3.37 1.39h111.77c1.09 0 1.34.62.57 1.39M482.82 656H630.9"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#34495e",
      "d": "M440.53 245.87l-31.7 31.48a5.52 5.52 0 0 1-3.37 1.39h-62.37c-1.09 0-2.6.62-3.38 1.39l-2.68 3.66-264.59.02c-1.08 0-2.6-.63-3.37-1.4l-47.3-46.97a5.52 5.52 0 0 0-3.37-1.39h-57.47l-1.12-34.61c0-1.08-.63-2.59-1.4-3.35l-66.54-65.94"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M705.31 221.73h7.83c1.09 0 2.6.63 3.37 1.4l45.8 45.6c.78.76 1.4 2.27 1.4 3.35v13.94c0 1.08.46 1.96 1.03 1.98.56 0 1.03.9 1.03 1.98v10.77l-.15 110.84c0 1.08-.89 1.96-1.98 1.96H628.32c-1.08 0-2.6-.63-3.37-1.4l-12.2-12.12a5.52 5.52 0 0 0-3.38-1.39h-46.18a2 2 0 0 0-2 1.96l-.17 26.74c0 1.08-.63 2.59-1.4 3.35l-8.82 8.76a5.52 5.52 0 0 1-3.37 1.39l-26.65-.06c-1.09 0-2.6.62-3.38 1.39l-48.1 47.78a5.52 5.52 0 0 1-3.38 1.39h-16.37l-79.45-.02c-1.09 0-2.6.63-3.36 1.39L220.71 639.06a5.47 5.47 0 0 1-3.35 1.4H31.06"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#34495e",
      "d": "M145.43 99.41L289.6 243.5c.77.76 2.29 1.39 3.37 1.39h146.76c1.09 0 2.6.62 3.38 1.39l31.93 31.71c.77.77 1.4 2.27 1.4 3.35V474.1c0 1.08-.63 2.59-1.4 3.35l-7.6 7.54a5.52 5.52 0 0 1-3.36 1.4h-20.62l-20.67 20.97-2.78 2.78L289.37 640a5.45 5.45 0 0 0-1.4 3.35l.16 177.85"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#34495e",
      "d": "M318.82 380.62h94.88c1.09 0 2.6.63 3.38 1.39l14.97 14.87c.77.76 2.29 1.39 3.37 1.39h72.99c1.08 0 2.6.63 3.35 1.39l58.57 58.53c.77.77 2.27 1.4 3.35 1.4h103.37c1.08 0 1.97-.89 1.97-1.97v-14.7c0-1.09-.89-1.97-1.97-1.97l-6.7.02H630.1a1.97 1.97 0 0 1-1.97-1.96v-57c0-1.08-.63-2.59-1.4-3.35l-14.58-14.48a5.45 5.45 0 0 1-1.4-3.35v-17.3c0-1.07-.63-2.58-1.4-3.34L597 327.92a5.52 5.52 0 0 0-3.37-1.39h-17.4c-1.09 0-2.6-.62-3.38-1.39l-41.8-41.5a5.52 5.52 0 0 0-3.37-1.4h-41.34"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFFFFF"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M855.2 194.4h59.84c1.09 0 1.97.89 1.97 1.96v28.74c0 1.08.64 2.59 1.4 3.35l50.96 50.6c.77.76 1.4 2.27 1.4 3.35v101.47l105.2 104.27"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#34495e",
      "d": "M638.46 305.73L651 293.29c.77-.74.77-2 0-2.76l-31.35-31.13c-.76-.74-.76-2 0-2.76l18.53-18.4a5.52 5.52 0 0 1 3.37-1.39l160.41-.2 423.37 1.2c1.08 0 1.97.89 1.97 1.96v71.5"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFFFFF",
      "d": "M438.61 486.03h-18.54c-1.08 0-2.6-.63-3.37-1.4l-74.94-74.41a5.52 5.52 0 0 0-3.37-1.4h-38.57c-1.08 0-2.6-.62-3.37-1.38l-47-46.68-36.58-.04-57 71.59a5.45 5.45 0 0 0-1.4 3.35v23.9"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M882.06 358.97l-46.92 46.6a5.52 5.52 0 0 1-3.38 1.39h-94.64c-1.09 0-2.6-.63-3.38-1.4l-30.6-30.33a5.52 5.52 0 0 0-3.36-1.4l-34.94.04c-1.08 0-2.6.63-3.37 1.4l-29.57 29.36a5.52 5.52 0 0 1-3.37 1.39l-14.55-14.35a5.63 5.63 0 0 0-3.42-1.4l-156.97-.25c-1.11 0-2.65.63-3.43 1.4l-27.85 27.61a5.52 5.52 0 0 1-3.38 1.4H-23.82l-88.65.2-12.44 12.35"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M292.9 643.74l59.56-59.12a5.52 5.52 0 0 1 3.37-1.39h23.93c1.08 0 2.6-.63 3.37-1.39l46.53-46.21a5.52 5.52 0 0 1 3.38-1.4h33.53l153.67-.01c1.08 0 1.97-.88 1.97-1.96V420.01c0-1.07-.63-2.58-1.4-3.35l-38.64-38.37a5.45 5.45 0 0 1-1.4-3.35v-51.52c0-1.08-.64-2.59-1.4-3.35L468.91 210.39a5.52 5.52 0 0 0-3.38-1.4l-180.49.2"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M484.13 548.71h-37.09c-1.08 0-2.6.63-3.37 1.4l-69.02 68.54c-.77.76-.77 2 0 2.76l28.09 27.78c.77.76 2.29 1.39 3.37 1.39h62.41"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M520.82 561.7v-4.74c0-1.08-.89-1.96-1.98-1.96h-13.21c-1.09 0-2.6-.62-3.37-1.39l-43.36-42.88a5.45 5.45 0 0 1-1.4-3.35v-190.4c0-1.08.63-2.6 1.4-3.36l20.89-20.74a5.45 5.45 0 0 0 1.4-3.35v-95.4c0-1.08-.63-2.58-1.4-3.35L292.4 4.7l-.6-40.88c0-1.08-.62-2.58-1.4-3.35L278.8-51.07"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M275.76 745h99.28c1.09 0 2.6-.63 3.38-1.4l174.33-172.75a5.52 5.52 0 0 1 3.38-1.4h46.75c1.08 0 2.6-.62 3.35-1.38l51.47-51.46a5.42 5.42 0 0 0 1.38-3.35V311.29c0-1.07-.63-2.58-1.4-3.35l-51.84-51.3a5.52 5.52 0 0 0-3.38-1.4h-17.95a1.97 1.97 0 0 1-1.97-1.95v-44.47c0-1.07-.89-1.96-1.97-1.96h-88.63a1.97 1.97 0 0 1-1.97-1.96v-19.2c0-1.07-.64-2.58-1.4-3.34L309.87 4.92"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M1002.65 123.83H926.5c-1.08 0-2.6.62-3.37 1.39l-92.28 91.46a5.52 5.52 0 0 1-3.37 1.39l-131.87-.08c-1.09 0-2.6.63-3.37 1.37l-51.9 51.19c-.77.76-.77 2 0 2.76l21.22 21.1c.77.76 1.4 2.27 1.4 3.35v15.69"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M672.51 437.64h54.25c1.08 0 2.6.63 3.37 1.4l49.04 48.7c.77.76 2.29 1.38 3.37 1.38h45.16c1.08 0 2.6-.62 3.37-1.39L914.39 405a5.52 5.52 0 0 1 3.37-1.4h42.22c1.08 0 2.6.63 3.37 1.4l100.8 100.1"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M672.51 434.31h55.63c1.08 0 2.6.63 3.37 1.4l49.14 48.8c.77.76 2.29 1.38 3.37 1.38l41.9-.04c1.08 0 2.6-.62 3.37-1.39l62.08-61.68a5.45 5.45 0 0 0 1.4-3.35l-.1-268.18c0-1.08-.63-2.59-1.4-3.35l-99.8-99.28a5.52 5.52 0 0 0-3.37-1.39H422.62c-1.08 0-2.6.63-3.37 1.4L260.28 206.3a5.52 5.52 0 0 1-3.38 1.39H127.3c-1.08 0-2.6.62-3.37 1.39l-36.71 36.45a5.45 5.45 0 0 0-1.4 3.35v185.1"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M410.1 713.73l17.53 17.42c.77.76 2.29 1.39 3.37 1.39h42.02c1.09 0 2.6-.63 3.37-1.4l26.02-25.83 123.2-.31"
    }
  }), _c('path'), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M307.34 907.08c.77-.77.52-1.4-.57-1.4H108.29a1.97 1.97 0 0 1-1.98-1.95V743.59c0-1.08.9-1.96 1.98-1.96h264.38c1.09 0 2.6-.63 3.38-1.4l23.75-23.58c.77-.76.77-2 0-2.76l-80.84-80.1c-.77-.76-.51-1.4.57-1.4h137.53c1.09 0 2.6-.62 3.38-1.38l53.63-53.26a5.52 5.52 0 0 1 3.37-1.4l88.57-.2c1.09 0 2.6-.62 3.38-1.38l55.6-55.22a5.45 5.45 0 0 0 1.4-3.35V409.93c0-1.08.9-1.96 1.98-1.96h29c1.08 0 2.6-.63 3.37-1.4l43.32-43.01a5.52 5.52 0 0 1 3.37-1.4h6.11c1.09 0 2.6-.62 3.38-1.38l53.12-52.76a5.52 5.52 0 0 1 3.37-1.39h13.6c1.08 0 2.6.63 3.37 1.4L892.79 370c.77.77 2.29 1.4 3.37 1.4h74.06c1.08 0 2.6.62 3.37 1.38l93.97 93.5"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M647.56 429.46v-33.62c0-1.08-.63-2.59-1.4-3.35l-31.45-31.22a5.52 5.52 0 0 0-3.37-1.4h-36.87c-1.08 0-2.6.63-3.37 1.4l-74.35 73.83a5.52 5.52 0 0 1-3.37 1.39H440.9a1.97 1.97 0 0 1-1.98-1.96v-71.5c0-1.08-.88-1.96-1.97-1.96H9.3c-1.08 0-2.6.63-3.37 1.4l-37.9 37.62a5.52 5.52 0 0 1-3.37 1.4h-57c-1.1 0-2.61.62-3.38 1.38l-13.2 13.1a5.52 5.52 0 0 1-3.37 1.4h-13.2"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M219.9 357h144.49l76.54.13c1.08 0 1.97.88 1.97 1.96v71.7c0 1.08.89 1.96 1.97 1.96h46.36c1.08 0 2.6-.63 3.37-1.4l74.35-74a5.52 5.52 0 0 1 3.37-1.4h192.33c1.09 0 2.6-.62 3.37-1.38l43.58-43.28a5.52 5.52 0 0 1 3.37-1.39h10.6c1.08 0 2.6.63 3.37 1.4l62.65 62.2c.77.77 2.29 1.4 3.37 1.4h73.87c1.09 0 2.6.63 3.38 1.4l94.12 93.47 9.27.57c.84 0 2.17-.62 2.93-1.39l104.08-89.36a1.97 1.97 0 0 1 2.78 0l6.3 6.25"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M599.92 564.19a6.6 6.6 0 0 0 4.04-1.67l47.94-47.6a6.5 6.5 0 0 0 1.67-4.01V313.84c0-1.3-.75-3.1-1.67-4.02l-47.94-47.6a6.6 6.6 0 0 0-4.04-1.66h-97.84a6.6 6.6 0 0 0-4.05 1.66l-47.93 47.6a6.5 6.5 0 0 0-1.68 4.02v197.07c0 1.29.75 3.1 1.68 4.01l47.93 47.6a6.6 6.6 0 0 0 4.05 1.67h97.84z"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M648.25 527.17v33.3c0 1.08-.63 2.58-1.4 3.35l-87.37 86.76c-.77.76-.51 1.39.57 1.39h70.82"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M476.04 273.32v-18.86c0-1.08-.63-2.59-1.4-3.35l-30.9-30.68a5.52 5.52 0 0 0-3.37-1.4H274.62"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#3498db",
      "d": "M923.43 372.6V119.09c0-1.07-.64-2.58-1.4-3.34L757.4-47.74a5.52 5.52 0 0 0-3.37-1.39H351.57c-1.09 0-2.6.63-3.38 1.4L310.5-10.3"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M317-49.77L304.42-37.3a5.58 5.58 0 0 0-1.42 3.35l-.36 21.45a5.3 5.3 0 0 0 1.36 3.35L493.36 178.9c.77.76 1.4 2.27 1.4 3.35v18.41c0 1.08.89 1.96 1.97 1.96h87.86c1.09 0 1.98.88 1.98 1.96v34.67c0 1.08.88 1.96 1.97 1.96h23.3c1.08 0 2.6.63 3.37 1.4l46.16 45.83c.77.77 1.4 2.28 1.4 3.35v138.64l.07 84.4c0 1.08-.63 2.6-1.38 3.35l-53.63 53.27a5.52 5.52 0 0 1-3.37 1.39H557.9c-1.08 0-2.6.63-3.37 1.39L380.57 746.98a5.52 5.52 0 0 1-3.38 1.39H112.47c-1.09 0-1.97.88-1.97 1.96v93.24c0 1.08-.9 1.96-1.98 1.96h-224.54"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M415.07 612.97l63.3-62.86a5.52 5.52 0 0 1 3.37-1.4h124.67c1.08 0 2.6-.6 3.37-1.37l28.23-27.83a5.35 5.35 0 0 0 1.4-3.33V478.2c0-1.07.89-1.96 1.97-1.96H694c1.09 0 1.97-.88 1.97-1.95v-52.11c0-1.08.64-2.59 1.4-3.35l29.57-29.37a5.45 5.45 0 0 0 1.4-3.35v-76c0-1.08.9-1.96 1.98-1.96h37.9a4 4 0 0 0 4-4v-29.3c0-1.08.63-2.59 1.4-3.35l35.35-35"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M893.1 374.7L847.5 420a5.52 5.52 0 0 1-3.37 1.38H618.66c-1.09 0-2.6-.62-3.37-1.39l-81.65-81.08a5.52 5.52 0 0 0-3.37-1.39H384.49c-1.08 0-2.6.63-3.37 1.4l-17.14 17.02"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M288.52 640.2h-46.9c-1.09 0-1.98.88-1.98 1.95v26.65c0 1.07-.89 1.95-1.97 1.95h-89.32"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M281.34 229.6l9.65 9.59c.77.76 2.29 1.39 3.37 1.39l146.76-.2c1.09 0 2.6.63 3.38 1.37l115.95 114c.77.76.77 1.99 0 2.75l-37.2 37.05a1.96 1.96 0 0 0 0 2.78l49.62 49.28c.77.77 2.3 1.4 3.38 1.4h138.28c1.08 0 2.6.62 3.37 1.39l37.26 37c.77.76 2.3 1.4 3.38 1.4h21.7"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M-116.02 841.87h216.77c1.09 0 1.97-.89 1.97-1.96v-99.83c0-1.08.9-1.96 1.98-1.96h266.24c1.08 0 2.6-.62 3.37-1.39l20.18-20.04c.77-.76.77-2.02 0-2.76l-78.7-78.2a5.45 5.45 0 0 1-1.4-3.35v-1.57c0-1.07.88-1.96 1.97-1.96l139.22.02c1.09 0 2.6-.62 3.38-1.39l53.7-53.48a4.86 4.86 0 0 1 2.8-1.39c.76 0 1.41-.88 1.41-1.96v-6.62"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M317.92 257.82l73.16 72.65c.77.77 1.4 2.27 1.4 3.35v45.25c0 1.08.63 2.59 1.4 3.35l12.02 11.93c.77.77 2.28 1.4 3.37 1.4h9.86c1.09 0 2.6-.63 3.38-1.4l6.29-6.25a5.52 5.52 0 0 1 3.37-1.39h85.81c1.08 0 2.6-.62 3.37-1.39l63.1-62.66a5.52 5.52 0 0 1 3.38-1.4h161.56c1.08 0 1.97.89 1.97 1.96v178.66c0 1.07-.63 2.58-1.4 3.35l-11.42 11.34a5.52 5.52 0 0 1-3.38 1.39H529.03a1.97 1.97 0 0 1-1.98-1.96v-73.07c0-1.07-.88-1.96-1.97-1.96h-88.26a1.97 1.97 0 0 1-1.97-1.95V406.5c0-1.08-.89-1.96-1.97-1.96-1.99 0-3.5-.63-4.28-1.4l-7.44-7.38"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M650.42-78.35v211.36c0 1.08.63 2.59 1.4 3.35l46.73 46.4c.77.77 1.4 2.28 1.4 3.36v35.79l-2.49-.14c-.75 0-1.97.63-2.74 1.4l-18.32 18.19a5.45 5.45 0 0 0-1.4 3.35v116.95c0 1.07.63 2.58 1.38 3.35l46.53 46.58a5.42 5.42 0 0 1 1.38 3.35l-.02 30.34c0 1.08-.63 2.59-1.4 3.35l-4.91 4.88a5.52 5.52 0 0 1-3.37 1.4H599.52c-1.08 0-1.97.87-1.97 1.95v36c0 1.08-.89 1.96-1.97 1.96h-92.71c-1.09 0-2.6.63-3.38 1.4l-19.58 19.45a5.52 5.52 0 0 1-3.38 1.39h-63.61"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M281.48 745v84.33c0 1.08-.89 1.96-1.97 1.96h-57.48c-1.09 0-1.98.88-1.98 1.96v10.36c0 1.08-.88 1.96-1.97 1.96H110.52"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M10.95 362.32l113.4 112.62c.78.77 2.3 1.4 3.38 1.4h36.12c1.08 0 2.6.62 3.37 1.38l205.45 204.03c.77.76 2.29 1.39 3.37 1.39l62.74.03h29.53c1.09 0 2.6.63 3.37 1.4l16.36 16.23c.77.77 2.29 1.4 3.37 1.4h134.34"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M275.82 590.44l24.44-24.27a5.52 5.52 0 0 1 3.37-1.4h121.52c1.08 0 2.6.63 3.37 1.4l34.32 34.08c.77.77 2.3 1.4 3.38 1.4h54.36"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M633.41 278.74l-21.36-21.22a5.45 5.45 0 0 1-1.4-3.35V-78.58"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M754.4 192.02v20.11c0 1.08-.9 1.96-1.98 1.96h-94.49c-1.08 0-2.6.63-3.37 1.4l-50.28 49.93a5.45 5.45 0 0 0-1.4 3.35v56.41c0 1.08.63 2.59 1.4 3.35l10.63 10.56c.77.76 1.4 2.27 1.4 3.35v121.45c0 1.08-.89 1.96-1.97 1.96H429.6c-1.08 0-2.6-.62-3.37-1.39l-21.2-21.06-15.77 14.8a5.52 5.52 0 0 1-3.37 1.38H282.15c-1.08 0-2.6.63-3.37 1.37l-62.1 61.3a5.5 5.5 0 0 1-3.37 1.37h-69.85c-1.09 0-2.6.63-3.37 1.4l-68.22 67.73a5.52 5.52 0 0 1-3.37 1.4H34.1c-1.09 0-2.6.62-3.38 1.38l-61.64 61.22a5.45 5.45 0 0 0-1.4 3.35v98.02c0 1.08-.89 1.96-1.97 1.96h-30.76c-1.08 0-2.6.63-3.37 1.4l-48.29 47.95"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M184.55 422.03v34.09c0 1.07-.63 2.58-1.4 3.35l-56.48 55.88a5.52 5.52 0 0 1-3.37 1.4H-34.6"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M980.12 416.59l-15.05-14.95a5.52 5.52 0 0 0-3.38-1.4h-46.04c-1.08 0-2.6.63-3.37 1.4l-14.5 14.4c-.77.76-1.4.5-1.4-.57v-34.93c0-1.08-.63-2.58-1.4-3.35l-2.48-2.47"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#2980b9",
      "d": "M826.77 238.25v54.43c0 1.08.63 2.59 1.4 3.35l86.38 85.78c.77.77 2.29 1.4 3.37 1.4h98.61c1.09 0 2.6-.63 3.36-1.4l22.6-22.8a5.47 5.47 0 0 1 3.36-1.39h106.38c1.08 0 1.97-.88 1.97-1.96l.04-95.24c0-1.08.89-1.96 1.97-1.96h39.02c1.09 0 1.97.88 1.97 1.96v48.1"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M12.87 361.05h-5c-1.1 0-2.61-.63-3.38-1.4l-17.72-17.58a5.52 5.52 0 0 0-3.37-1.4h-16.9c-1.09 0-2.6-.62-3.38-1.38l-55.64-55.26a5.52 5.52 0 0 0-3.38-1.4h-15.19"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M959.23 126.08l19.2 19.06c.76.76 2.28 1.39 3.36 1.39h177.42c1.09 0 1.97.88 1.97 1.96v100.84a3 3 0 0 0 3 3h36.42c1.08 0 1.97.88 1.97 1.96v54.65"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#ecf0f1",
      "d": "M33.17 798.75h242.12c1.08 0 1.97-.88 1.97-1.96V672.9c0-1.08-.89-1.96-1.97-1.96h-30.12a1.97 1.97 0 0 1-1.98-1.96v-26.76c0-1.07-.88-1.96-1.97-1.96h-20.87"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#34495e",
      "d": "M458.48 496.1h9.55c1.09 0 2.6-.63 3.37-1.4l48.23-47.83a5.52 5.52 0 0 1 3.38-1.39h24.26c1.08 0 2.6.63 3.37 1.39l23.26 23.1c.77.76 2.29 1.39 3.37 1.39h111.06c1.09 0 1.97-.88 1.97-1.96v-54.46c0-1.08-.63-2.59-1.4-3.33l-20.35-20.04-2.8-2.76-1.17-1.16a5.52 5.52 0 0 0-3.37-1.39h-11.66a1.97 1.97 0 0 1-1.97-1.96V310.6c0-1.08.88-1.96 1.97-1.96h77.38"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#34495e",
      "d": "M-34.94 402.19v111.19c0 1.07.63 2.58 1.4 3.35l49.06 48.71c.76.77 2.28 1.4 3.37 1.4h21.8c1.08 0 2.6.62 3.37 1.39l113 112.22c.78.77 2.3 1.4 3.38 1.4h170.6c1.08 0 1.97.87 1.97 1.95v60.41"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('background-anim'), _vm._v(" "), _c('div', {
    staticClass: "left-inner"
  }, [_c('div', {
    staticClass: "left-bg"
  }, [_c('div', {
    staticClass: "botui-app-container",
    attrs: {
      "id": "my-botui-app"
    }
  }, [_c('bot-ui')], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('h3', [_vm._v("Projects")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-title"
  }, [_vm._v("Microservices")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Development of MAP (Media Application Platform) using suite of AWS services")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(AWS - Lambda, API Gateway, S3, DynamoDB, Cognito, SNS, Cloudfront).")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-title"
  }, [_vm._v("Emoji CMS")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Managing and developing the CMS that supports the Emoji business that includes Container apps, sticker packs and keyboard extensions on iOS platform")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(1M+ downloads and 100k+ daily active users)")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-title"
  }, [_vm._v("Stoopidland")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Lead the development of Container, Keyboard extension and Sticker extension for the Stoopidland Project")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(Swift, Realm, In-app purchases, configs, analytics)")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "http://ehow.com",
      "target": "_blank"
    }
  }, [_vm._v("eHow")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("DIY site getting 75 Million+ visits/month")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(Javascript, NodeJS, Firebase, React, Redux, EmberJS, New Relic)")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "http://techwalla.com/",
      "target": "_blank"
    }
  }, [_vm._v("Techwalla")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Tech review site that provides metacritic data")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Lead the development of UI/UX on the site")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "https://animeshmanglik.name/",
      "target": "_blank"
    }
  }, [_vm._v("animeshmanglik.name")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Resume TL; DR")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(VueJS, AWS, NodeJS)")])])])])
}]}

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
module.exports = __webpack_require__(2);


/***/ })
],[64]);


// WEBPACK FOOTER //
// static/js/app.1b67a573273b121895fa.js